import { render, staticRenderFns } from "./MyHome.vue?vue&type=template&id=e08b4d8c&scoped=true"
import script from "./MyHome.vue?vue&type=script&lang=js"
export * from "./MyHome.vue?vue&type=script&lang=js"
import style0 from "./MyHome.vue?vue&type=style&index=0&id=e08b4d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08b4d8c",
  null
  
)

export default component.exports